<div class="keyboard-help">
  <div mat-dialog-title class="dialog-title">
    <mat-icon>keyboard</mat-icon>
    <h2>Keyboard Shortcuts</h2>
    <button mat-icon-button 
            mat-dialog-close
            class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div mat-dialog-content class="dialog-content">
    
    <!-- Playback Controls -->
    <div class="shortcut-section">
      <h3>
        <mat-icon>play_circle</mat-icon>
        Playback Controls
      </h3>
      <div class="shortcuts-grid">
        <div *ngFor="let shortcut of playbackShortcuts" class="shortcut-item">
          <span class="shortcut-key">{{ formatShortcut(shortcut) }}</span>
          <span class="shortcut-description">{{ shortcut.description }}</span>
        </div>
      </div>
    </div>

    <!-- Volume Controls -->
    <div class="shortcut-section">
      <h3>
        <mat-icon>volume_up</mat-icon>
        Volume Controls
      </h3>
      <div class="shortcuts-grid">
        <div *ngFor="let shortcut of volumeShortcuts" class="shortcut-item">
          <span class="shortcut-key">{{ formatShortcut(shortcut) }}</span>
          <span class="shortcut-description">{{ shortcut.description }}</span>
        </div>
      </div>
    </div>

    <!-- Seeking Controls -->
    <div class="shortcut-section">
      <h3>
        <mat-icon>fast_forward</mat-icon>
        Seeking & Navigation
      </h3>
      <div class="shortcuts-grid">
        <div *ngFor="let shortcut of seekingShortcuts" class="shortcut-item">
          <span class="shortcut-key">{{ formatShortcut(shortcut) }}</span>
          <span class="shortcut-description">{{ shortcut.description }}</span>
        </div>
      </div>
    </div>

    <!-- Media Keys -->
    <div class="shortcut-section" *ngIf="mediaKeyShortcuts.length > 0">
      <h3>
        <mat-icon>keyboard_alt</mat-icon>
        Media Keys
      </h3>
      <div class="shortcuts-grid">
        <div *ngFor="let shortcut of mediaKeyShortcuts" class="shortcut-item">
          <span class="shortcut-key">{{ formatShortcut(shortcut) }}</span>
          <span class="shortcut-description">{{ shortcut.description }}</span>
        </div>
      </div>
      <p class="media-keys-note">
        <mat-icon>info</mat-icon>
        Media keys may not work in all browsers or operating systems.
      </p>
    </div>

    <!-- Usage Tips -->
    <div class="shortcut-section">
      <h3>
        <mat-icon>tips_and_updates</mat-icon>
        Tips
      </h3>
      <ul class="tips-list">
        <li>
          <mat-icon>check_circle</mat-icon>
          Keyboard shortcuts work when the player is active and you're not typing in an input field.
        </li>
        <li>
          <mat-icon>check_circle</mat-icon>
          Use number keys (0-9) to quickly jump to different parts of a track.
        </li>
        <li>
          <mat-icon>check_circle</mat-icon>
          Hold Shift with arrow keys for track navigation, Ctrl for seeking.
        </li>
        <li>
          <mat-icon>check_circle</mat-icon>
          Press Spacebar for quick play/pause without clicking.
        </li>
      </ul>
    </div>
  </div>

  <div mat-dialog-actions class="dialog-actions">
    <button mat-button 
            mat-dialog-close
            color="primary">
      Got it!
    </button>
  </div>
</div>